import { BaseProps } from '@/types/BaseProps';
import { Tooltip } from '../Tooltip';
import styles from './Button.module.css';

export interface ButtonProps extends BaseProps {
	type: 'button' | 'submit';
	children: string | JSX.Element | JSX.Element[];
	variant?: 'primary' | 'secondary' | 'tertiary' | 'cart' | 'success' | 'error';
	size?: 'xs' | 'sm';
	className?: string;
	disabled?: boolean;
	form?: string;
	icon?: React.ReactNode;
	iconPosition?: 'before' | 'after';
	tooltipText?: string;
	outlined?: boolean;
	handleButtonClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function Button(props: ButtonProps) {
	const {
		type,
		children,
		variant = 'primary',
		size = 'sm',
		className,
		icon,
		iconPosition,
		disabled,
		form,
		handleButtonClick,
		tooltipText,
		outlined,
	} = props;

	const renderIcon = () => {
		if (icon) {
			return <span className={`${styles.icon}`}>{icon}</span>;
		}
	};

	return (
		<div className={`${styles.buttonWrapper} ${disabled ? styles.isDisabled : ''}`}>
			<Tooltip text={tooltipText}>
				<button
					data-testid={props['data-testid']}
					type={type}
					className={`${styles.button} ${styles[variant]} ${styles[size]} ${className} ${outlined ? styles.outlined : ''}`}
					disabled={disabled}
					onClick={handleButtonClick}
					form={form}
				>
					{iconPosition === 'before' && renderIcon()}
					{children}
					{iconPosition === 'after' && renderIcon()}
				</button>
			</Tooltip>
		</div>
	);
}

export default Button;
